"use strict";
exports.__esModule = true;
var _ = require('underscore');
var COLOR_LIST = ['#538DDA', '#76933A', '#BF80BA', '#4BACCA', '#7A714A',
    '#449E9A', '#CC646A', '#FFD70A', '#BDB76A', '#6B8E2A', '#36609A'];
var AddTable = /** @class */ (function () {
    function AddTable(masterTable, pnl, addTableConfig, actionMenuItem) {
        this.pnl = pnl;
        this.colors = addTableConfig.config.colors;
        if ("shadowColors" in addTableConfig.config) {
            this.shadowColors = addTableConfig.config.shadowColors;
        }
        this.specialRules = addTableConfig.config.specialRules;
        this.masterTable = masterTable;
        this.title = actionMenuItem + " for " + masterTable.name;
        this.reportName = actionMenuItem;
        this.projectName = masterTable.name;
        this.tableHeader = masterTable.colHeader;
        this.minHeaderIndex = 1;
        this.produceTable(masterTable);
        var ignoreCol = undefined;
        if (addTableConfig.displayRules) {
            for (var i = 0; i < addTableConfig.displayRules.length; i++) {
                if (addTableConfig.displayRules[i].RULE == "IGNORE_COL_IN_CHARTS") {
                    ignoreCol = addTableConfig.displayRules[i].ColHeader;
                }
            }
        }
        this.matrix = new Matrix(this.produceMatrixData(ignoreCol));
        this.makeDisplayRules(addTableConfig);
    }
    AddTable.prototype.makeDisplayRules = function (config) {
        var _this = this;
        var rules = {};
        if (!config.specialRules && !config.displayRules) {
            this.displayRules = this.tableHeader.map(function (item) {
                return {
                    'format': true,
                    'tooltip': false
                };
            });
            return;
        }
        var rulesLists = [];
        if (config.specialRules)
            rulesLists = rulesLists.concat(config.specialRules);
        if (config.displayRules)
            rulesLists = rulesLists.concat(config.displayRules);
        rulesLists.forEach(function (item) {
            if (item.ColHeader in rules) {
                rules[item.ColHeader]['format'] = item['RULE'] !== 'YEAR';
                rules[item.ColHeader]['high'] = rules[item.ColHeader]['High'] || item['high'] || false;
                rules[item.ColHeader]['tooltip'] = rules[item.ColHeader]['tooltip'] || item['Tooltip'] || false;
                rules[item.ColHeader]['veryLargeText'] = rules[item.ColHeader]['veryLargeText'] || item['VeryLargeText'] || false;
            }
            else {
                var rule = {};
                rule['format'] = item['RULE'] !== 'YEAR';
                rule['tooltip'] = item['Tooltip'] || false;
                rule['high'] = item['High'] || false;
                rule['veryLargeText'] = item['VeryLargeText'] || false;
                rules[item.ColHeader] = rule;
            }
        });
        this.displayRules = [];
        this.tableHeader.forEach(function (item) {
            if (item in rules) {
                _this.displayRules.push(rules[item]);
            }
            else {
                _this.displayRules.push({
                    'format': true,
                    'tooltip': false
                });
            }
        });
    };
    AddTable.prototype.produceMatrixData = function (ignoreCol) {
        var result = [];
        var pnl = this.pnl;
        var ignoreColIndices = [];
        result.push(_.map(this.tableHeader, function (col, index) {
            if (col === ignoreCol || index === 0) {
                ignoreColIndices.push(index);
                return col;
            }
            else {
                return (pnl && typeof col !== 'string') ? parseFloat(col) : col;
            }
        }));
        return result.concat(_.map(this.table, function (ele) {
            return _.map(ele['rolledUpLine'], function (col, index) {
                return index === 0 || ignoreColIndices.indexOf(index) > -1 ? col : parseFloat(col);
            });
        }));
    };
    AddTable.prototype.produceTable = function (masterTable) {
        var _this = this;
        this.table = [];
        _.each(masterTable.lines, function (line, index) {
            _this.table.push({
                'rolledUpLine': line.rolledUpLine,
                'format': 'Parent',
                'expanded': false,
                'masterIndex': index
            });
        });
    };
    AddTable.prototype.rightShiftYear = function () {
        var largest = this.tableHeader.length - 1;
        if (this.minHeaderIndex < largest)
            this.minHeaderIndex++;
    };
    AddTable.prototype.leftShiftYear = function () {
        if (this.minHeaderIndex > 1)
            this.minHeaderIndex--;
    };
    AddTable.prototype.getColChartData = function () {
        var _this = this;
        var matrixData = this.matrix.data;
        var drillDownData = {};
        var seriesCount = this.matrix.colCount - 1;
        if (this.masterTable.lines) {
            var drillDownNames = this.masterTable.lines[0]['children'].map(function (c) { return c[0]; });
            var _loop_1 = function (i) {
                var year = this_1.masterTable.colHeader[i + 1];
                var drillDown = drillDownNames.map(function (name, idx) { return ({
                    type: 'area',
                    name: name,
                    color: COLOR_LIST[idx % COLOR_LIST.length],
                    data: _this.masterTable.lines.map(function (line) { return line['children'][idx][i + 1]; })
                }); });
                var sum = function (elem) { return elem.data.reduce(function (a, b) { return a + b; }); };
                drillDown.sort(function (a, b) { return sum(a) - sum(b); });
                drillDownData[year] = drillDown;
            };
            var this_1 = this;
            for (var i = 0; i < seriesCount; i++) {
                _loop_1(i);
            }
        }
        return { matrixData: matrixData, drillDownData: drillDownData };
    };
    AddTable.prototype.getRowChartData = function () {
        var matrixData = this.matrix.transpose().data;
        var drillDownData = {};
        this.masterTable.lines.forEach(function (line) {
            var seriesName = line['rolledUpLine'][0];
            var drillDown = line['children'].map(function (child, idx) { return ({
                type: 'area',
                name: child[0],
                data: child.slice(1),
                color: COLOR_LIST[idx % COLOR_LIST.length]
            }); });
            var sum = function (elem) { return elem.data.reduce(function (a, b) { return a + b; }); };
            drillDown.sort(function (a, b) { return sum(a) - sum(b); });
            drillDownData[seriesName] = drillDown;
        });
        return { matrixData: matrixData, drillDownData: drillDownData };
    };
    AddTable.prototype.triggerLineExpand = function (index, isShadow, isGroupBy, groupbyColor, isColorBy) {
        var masterIndex = this.table[index].masterIndex;
        if (this.table[index].expanded) {
            this.closeLine(index, masterIndex);
        }
        else {
            this.expandLine(index, masterIndex, isShadow, isGroupBy, groupbyColor, isColorBy);
        }
        this.table[index].expanded = !this.table[index].expanded;
    };
    AddTable.prototype.expandLine = function (index, masterIndex, isShadow, isGroupBy, groupbyColor, isColorBy) {
        var childrenLines = _.map(this.masterTable.lines[masterIndex].children, function (item) {
            return {
                'rolledUpLine': item,
                'format': 'Children',
                'expanded': false
            };
        });
        if (isColorBy) {
            if (!isShadow) {
                for (var i = 0; i < childrenLines.length; i++) {
                    if (isGroupBy) {
                        childrenLines[i]['color'] = groupbyColor;
                    }
                    else {
                        childrenLines[i]['color'] = this.colors[i];
                    }
                }
            }
            else {
                for (var i = 0; i < childrenLines.length; i++) {
                    childrenLines[i]['color'] = this.shadowColors[i];
                }
            }
        }
        Array.prototype.splice.apply(this.table, [index + 1, 0].concat(childrenLines));
    };
    AddTable.prototype.closeLine = function (index, masterIndex) {
        var childrenLength = this.masterTable.lines[masterIndex].children.length;
        this.table.splice(index + 1, childrenLength);
    };
    AddTable.prototype.exportCSV = function (detailed, mode, muitipleTables, displayRules, includeNodeInfo, includeActionInfo, breadcrumbs) {
        var _this = this;
        if (mode === void 0) { mode = "includeAll"; }
        if (muitipleTables === void 0) { muitipleTables = false; }
        if (includeNodeInfo === void 0) { includeNodeInfo = false; }
        if (includeActionInfo === void 0) { includeActionInfo = false; }
        if (breadcrumbs === void 0) { breadcrumbs = null; }
        var ret = "";
        if (this.masterTable.path) {
            ret = this.title + " for " + this.masterTable.path + "\n";
        }
        else {
            if (muitipleTables === true) {
                ret = '"' + this.title + '"\n';
            }
        }
        if (!this.masterTable.path && muitipleTables === false) {
            ret = '"' + this.title + '"\n';
        }
        var header = _.map(this.tableHeader, function (item) {
            return isNaN(item) ? "\"" + item + "\"" : item;
        });
        header.splice(0, 1);
        if (includeNodeInfo) {
            header = 'Node,Project Node, Line Item,' + header.join(',') + '\n';
        }
        else {
            if (mode === "skipSummaryLines") {
                header = '"Line Item","Node",' + header.join(',') + '\n';
            }
            else {
                header = ',' + header.join(',') + '\n';
                if (detailed) {
                    header = 'Line Item,Node' + header;
                }
                else {
                    header = 'Line Item' + header;
                }
            }
        }
        if (includeActionInfo) {
            header = '"Report",' + header;
        }
        ret += header;
        _.each(this.masterTable.lines, function (lineItem) {
            var line = _.map(lineItem.rolledUpLine, function (colItem, index) {
                if (displayRules && displayRules[index]['high'] &&
                    parseFloat(colItem) == parseFloat(displayRules[index]['high'])) {
                    return displayRules[index]['veryLargeText'] || 'Very Large';
                }
                return isNaN(colItem) ? "\"" + colItem + "\"" : colItem;
            });
            if (detailed && !includeNodeInfo)
                line.splice(1, 0, '');
            if (mode !== "skipSummaryLines") {
                if (includeNodeInfo && includeActionInfo) {
                    ret += _this.reportName + ',,,' + line.join(',') + '\n';
                }
                else if (includeNodeInfo) {
                    ret += ',' + _this.projectName + ',' + line.join(',') + '\n';
                }
                else if (includeActionInfo) {
                    ret += _this.reportName + ',' + line.join(',') + '\n';
                }
                else {
                    ret += line.join(',') + '\n';
                }
            }
            if (detailed) {
                if (mode === "skipSummaryLines" && lineItem.children.length === 0) {
                    ret += '\n';
                }
                _.each(lineItem.children, function (childrenLine, index) {
                    var line = _.map(childrenLine, function (childrenLineItem, index) {
                        if (displayRules && displayRules[index]['high'] &&
                            parseFloat(childrenLineItem) == parseFloat(displayRules[index]['high'])) {
                            return displayRules[index]['veryLargeText'] || 'Very Large';
                        }
                        return isNaN(childrenLineItem) ? "\"" + childrenLineItem + "\"" : childrenLineItem;
                    });
                    if (includeNodeInfo) {
                        line.splice(0, 0, '"' + lineItem.childrenPath[index].replace(breadcrumbs + " > ", "") + '"');
                        line.splice(2, 0, '"' + lineItem.rolledUpLine[0] + '"');
                    }
                    if (includeNodeInfo && includeActionInfo) {
                        ret += '"' + _this.reportName + '",' + line.join(',') + '\n';
                    }
                    else if (includeNodeInfo) {
                        ret += line.join(',') + '\n';
                    }
                    else if (includeActionInfo) {
                        ret += '"' + _this.reportName + '","' + lineItem.rolledUpLine[0] + '",' + line.join(',') + '\n';
                    }
                    else {
                        ret += '"' + lineItem.rolledUpLine[0] + '",' + line.join(',') + '\n';
                    }
                });
            }
        });
        return ret;
    };
    AddTable.prototype.exportEuCSV = function (detailed, mode, shadow, exportConfig, breadcrumbs) {
        if (mode === void 0) { mode = "includeAll"; }
        if (exportConfig) {
            var euTsv = this.exportCSV(detailed, mode, shadow, false, exportConfig['IncludeNodeInfo'], exportConfig['IncludeActionInfo'], breadcrumbs);
        }
        else {
            var euTsv = this.exportCSV(detailed, mode, shadow, false, breadcrumbs);
        }
        euTsv = euTsv.replace(/,/g, ';');
        euTsv = euTsv.replace(/\./g, ',');
        return euTsv;
    };
    return AddTable;
}());
exports.AddTable = AddTable;
var AddTablesProvider = /** @class */ (function () {
    function AddTablesProvider(masterTables, addTableConfig, shadowTables, actionMenuItem, exportConfig) {
        var _this = this;
        this.addTableConfig = addTableConfig;
        this.pnl = addTableConfig.config.pnl;
        this.colors = addTableConfig.config.colors;
        this.legends = { 'names': [], 'colors': [] };
        this.exportConfig = exportConfig;
        if (addTableConfig.colorByList) {
            for (var i = 0; i < addTableConfig.colors.length; i++) {
                if (this.colors.indexOf(addTableConfig.colors[i]) !== -1) {
                    this.legends['names'].push(addTableConfig.colorByList[i]);
                    this.legends['colors'].push(addTableConfig.colors[i]);
                }
            }
        }
        this.precisionOptions = addTableConfig.config.precisionOptions;
        this.defaultPrecision = addTableConfig.config.defaultPrecision;
        this.masterTables = masterTables.map(function (mt) {
            var tempTable = mt;
            tempTable.lines = mt.lines.map(function (line) {
                if (line.rolledUpLine.join('').trim() === '') {
                    return { rolledUpLine: line.rolledUpLine, children: [] };
                }
                else {
                    return line;
                }
            });
            return tempTable;
        });
        this.tables = masterTables.map(function (masterTable) {
            return new AddTable(masterTable, _this.pnl, addTableConfig, actionMenuItem);
        });
        if (shadowTables) {
            this.shadowTables = shadowTables.map(function (masterTable) {
                return new AddTable(masterTable, _this.pnl, addTableConfig, actionMenuItem);
            });
        }
    }
    AddTablesProvider.prototype.handleIgnoreColInCharts_displayRule = function () {
        var ignoreColInCharts = [];
        this.addTableConfig.displayRules.filter(function (rule) {
            return rule.RULE === "IGNORE_COL_IN_CHARTS";
        }).forEach(function (rule) {
            if (typeof rule.ColHeader !== "string") {
                ignoreColInCharts = rule.ColHeader;
            }
            else {
                ignoreColInCharts.push(rule.ColHeader);
            }
        });
        return ignoreColInCharts;
    };
    AddTablesProvider.prototype.exportCSV = function (detailed, mode) {
        var _this = this;
        if (mode === void 0) { mode = "includeAll"; }
        var ret = "";
        var multipleTables = this.tables.length > 1;
        for (var i = 0; i < this.tables.length; i++) {
            if (!('displayRules' in this.tables[i])) {
                this.tables[i]['displayRules'] = null;
            }
        }
        var includeNodeInfo = false;
        var includeActionInfo = false;
        if (this.exportConfig) {
            includeNodeInfo = this.exportConfig['IncludeNodeInfo'];
            includeActionInfo = this.exportConfig['IncludeActionInfo'];
        }
        var tablesCSV = _.map(this.tables, function (table) {
            return table.exportCSV(detailed, mode, multipleTables, table.displayRules, includeNodeInfo, includeActionInfo, _this.masterTables[0].path);
        });
        if (this.shadowTables) {
            var shadowCSV = _.map(this.shadowTables, function (shadowTables) {
                return shadowTables.exportCSV(detailed, mode, multipleTables, shadowTables.displayRules, includeNodeInfo, includeActionInfo, _this.shadowTables[0].path);
            });
            tablesCSV = tablesCSV.concat(shadowCSV);
        }
        ret += tablesCSV.join('\n');
        return ret;
    };
    AddTablesProvider.prototype.exportEuCSV = function (detailed, mode) {
        var _this = this;
        if (mode === void 0) { mode = "includeAll"; }
        var ret = "";
        var shadow = this.tables.length > 1;
        var tablesCSV = _.map(this.tables, function (table) {
            return table.exportEuCSV(detailed, mode, shadow, _this.exportConfig, _this.masterTables[0].path);
        });
        if (this.shadowTables) {
            var shadowCSV = _.map(this.shadowTables, function (shadowTables) {
                return shadowTables.exportEuCSV(detailed, mode, shadow, _this.exportConfig, _this.shadowTables[0].path);
            });
            tablesCSV = tablesCSV.concat(shadowCSV);
        }
        ret += tablesCSV.join('\n');
        return ret;
    };
    return AddTablesProvider;
}());
exports.AddTablesProvider = AddTablesProvider;
var Matrix = /** @class */ (function () {
    function Matrix(rowsOrData) {
        this.colCount = 0;
        this.colShowStatus = [];
        this.rowShowStatus = [];
        if (typeof rowsOrData === "number") {
            this.rowCount = rowsOrData;
            this.initializeData();
        }
        else {
            this.rowCount = rowsOrData.length;
            this.initializeData(rowsOrData);
        }
    }
    Matrix.prototype.initializeData = function (initializingData) {
        this.data = [];
        for (var i = 0; i < this.rowCount; i++) {
            if (initializingData === undefined) {
                this.data.push([]);
            }
            else {
                this.data.push(initializingData[i].slice());
                if (initializingData[i].length > this.colCount) {
                    this.colCount = initializingData[i].length;
                    for (var j = 0; j < this.colCount; j++) {
                        this.colShowStatus[j] = true;
                    }
                }
            }
            this.rowShowStatus[i] = true;
        }
    };
    Matrix.prototype.set = function (row, col, data) {
        this.data[row][col] = data;
        if (col + 1 > this.colCount) {
            this.colCount = col + 1;
        }
    };
    Matrix.prototype.setRow = function (row, dataArray) {
        this.data[row] = dataArray;
        if (dataArray.length > this.colCount) {
            this.colCount = dataArray.length;
        }
    };
    Matrix.prototype.get = function (row, col) {
        return this.data[row][col];
    };
    Matrix.prototype.getRow = function (row) {
        return this.data[row];
    };
    Matrix.prototype.addToRow = function (row, data) {
        this.data[row].push(data);
        if (this.data[row].length > this.colCount) {
            this.colCount = this.data[row].length;
        }
    };
    Matrix.prototype.transpose = function () {
        var answer = new Matrix(this.colCount);
        for (var i = 0; i < this.rowCount; i++) {
            for (var j = 0; j < this.colCount; j++) {
                answer.set(j, i, this.get(i, j));
            }
        }
        answer.colShowStatus = [];
        for (var i = 0; i < answer.colCount; i++) {
            answer.colShowStatus.push(true);
        }
        return answer;
    };
    Matrix.prototype.rowHeaders = function () {
        var answer = [];
        for (var i = 1; i < this.rowCount; i++) {
            answer.push(this.data[i][0]);
        }
        return answer;
    };
    Matrix.prototype.colHeaders = function () {
        var answer = [];
        for (var i = 1; i < this.colCount; i++) {
            answer.push(this.data[0][i]);
        }
        return answer;
    };
    Matrix.prototype.colIndexByName = function (name) {
        return this.colHeaders().indexOf(name);
    };
    Matrix.prototype.rowIndexByName = function (name) {
        return this.rowHeaders().indexOf(name);
    };
    Matrix.prototype.deleteColumn = function (colIndex) {
        this.data.forEach(function (row) {
            row.splice(colIndex + 1, 1);
        });
        this.colCount--;
        this.colShowStatus.splice(colIndex, 1);
        return this.data;
    };
    Matrix.prototype.deleteRow = function (rowIndex) {
        this.data.splice(rowIndex + 1, 1);
        this.rowCount--;
        this.rowShowStatus.splice(rowIndex, 1);
        return this.data;
    };
    Matrix.prototype.withoutCols = function (columnNamesArray) {
        var answer = new Matrix(this.data);
        columnNamesArray.forEach(function (name) {
            var index = answer.colIndexByName(name);
            answer.deleteColumn(index);
        });
        return answer;
    };
    Matrix.prototype.withoutRows = function (rowNamesArray) {
        var answer = new Matrix(this.data);
        rowNamesArray.forEach(function (name) {
            var index = answer.rowIndexByName(name);
            answer.deleteRow(index);
        });
        return answer;
    };
    Matrix.prototype.trimEmptyCols = function () {
        var answer = new Matrix(this.data);
        var index = answer.colIndexByName("");
        while (index !== undefined && index > 0) {
            answer.deleteColumn(index);
            index = answer.colIndexByName("");
        }
        return answer;
    };
    Matrix.prototype.trimEmptyRows = function () {
        var answer = new Matrix(this.data);
        var index = answer.rowIndexByName("");
        while (index !== undefined && index > 0) {
            answer.deleteRow(index);
            index = answer.rowIndexByName("");
        }
        return answer;
    };
    Matrix.prototype.setColumnStatus = function (colIndex, show) {
        this.colShowStatus[colIndex] = show;
    };
    Matrix.prototype.setRowStatus = function (rowIndex, show) {
        this.rowShowStatus[rowIndex] = show;
    };
    Matrix.prototype.compact = function () {
        var newArray = [];
        for (var i = 0; i < this.rowCount; i++) {
            if (this.rowShowStatus[i] === true) {
                var newRow = [];
                for (var j = 0; j < this.data[i].length; j++) {
                    if (this.colShowStatus[j] === true) {
                        newRow.push(this.get(i, j));
                    }
                }
                //answer.colCount = newRow.length;
                newArray.push(newRow);
            }
        }
        return new Matrix(newArray);
    };
    Matrix.prototype.toDaisyMatrix = function () {
        var answer = new Matrix(1 + (this.rowCount - 1) * (this.colCount - 1));
        answer.setRow(0, [this.get(0, 0), "Desc", "Value"]);
        var rowCtr = 1;
        for (var col = 1; col < this.colCount; col++) {
            for (var row = 1; row < this.rowCount; row++) {
                answer.setRow(rowCtr, [this.get(0, col), this.get(row, 0), this.get(row, col)]);
                rowCtr = rowCtr + 1;
            }
        }
        return answer;
    };
    Matrix.prototype.toFormat = function (char) {
        var answer = "";
        for (var i = 0; i < this.data.length; i++) {
            for (var j = 0; j < this.data[i].length; j++) {
                answer = answer + this.data[i][j];
                if (j < this.data[i].length - 1) {
                    answer = answer + char;
                }
            }
            answer = answer + "\n";
        }
        return answer;
    };
    Matrix.prototype.toCsv = function () {
        return this.toFormat(",");
    };
    Matrix.prototype.toTsv = function () {
        return this.toFormat("\t");
    };
    return Matrix;
}());
exports.Matrix = Matrix;
exports["default"] = AddTable;
//# sourceMappingURL=addTablePy.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/add-tables/app/js/logic/addTablePy.js